export default {"src":"/_next/static/media/expat-logo-primary.23ddd9db.svg","height":54,"width":160,"blurWidth":0,"blurHeight":0};